import { render, staticRenderFns } from "./categoryDefaultList.vue?vue&type=template&id=4a678f93&scoped=true&"
import script from "./categoryDefaultList.vue?vue&type=script&lang=ts&"
export * from "./categoryDefaultList.vue?vue&type=script&lang=ts&"
import style0 from "./categoryDefaultList.vue?vue&type=style&index=0&id=4a678f93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a678f93",
  null
  
)

export default component.exports